import React, { useState } from 'react';

import { Modal } from 'design-system-web';
import { ServiceRequestFeedback } from './ServiceRequestFeedback';
import { type FeedbackFormData } from './ServiceRequestFeedbackForm';
import { ServiceRequestData } from './FeedbackButton';
import { useSubmitServiceRequestFeedback } from './useSubmitServiceRequestFeedback';
import { ServiceRequestFeedbackError } from '../../../errors/ServiceRequestFeedbackError';

export const ServiceRequestFeedbackModal = ({
  isOpen,
  onClose,
  onFeedbackSubmit,
  testId,
  serviceRequest,
}: {
  isOpen: boolean;
  onClose: Function;
  onFeedbackSubmit?: () => void;
  testId: string;
  serviceRequest: ServiceRequestData;
}) => {
  const { submitFeedback, loading } = useSubmitServiceRequestFeedback();
  const [error, setError] = useState<ServiceRequestFeedbackError | undefined>(
    undefined
  );

  const handleFormSubmit = async (data: FeedbackFormData) => {
    try {
      const success = await submitFeedback({
        serviceRequestId: serviceRequest.serviceRequestId,
        rating: data.rating,
        comment: data.comment,
      });

      if (success) {
        setError(undefined);
        onFeedbackSubmit?.();
        onClose();
      }
    } catch (error) {
      if (error instanceof ServiceRequestFeedbackError) {
        setError(error);
      } else {
        setError(
          new ServiceRequestFeedbackError(
            'An unexpected error occurred while submitting feedback'
          )
        );
      }
    }
  };

  const handleSkip = () => {
    setError(undefined);
    onClose();
  };

  const handleClose = () => {
    setError(undefined);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      testId={testId}
      closeButtonSize="medium"
      disableContentPadding
    >
      <ServiceRequestFeedback
        onSubmit={handleFormSubmit}
        error={error}
        onSkip={handleSkip}
        serviceRequest={serviceRequest}
        loading={loading}
      />
    </Modal>
  );
};
